// extracted by mini-css-extract-plugin
export default {"buoysPage":"BuoysPage_buoysPage__MPBpW","date":"BuoysPage_date__UksJY","data":"BuoysPage_data__w-dXI","active-row":"BuoysPage_active-row__4C2sN"};